import React from 'react';
import createReactClass from 'create-react-class';
import { t } from 'services/translation';
import FormControllerProxy from 'lib/form/controller_proxy';
import Textarea from 'views/ui/form_elements/textarea';
import classnames from 'classnames';
import styled from '@emotion/styled';
import { Grid, Theme } from 'views/anyguide/messages/styles';

import './index.scss';
import ThemeButton from 'ui_system/buttons/ThemeButton';

const Toggle = styled('span')`
  font-size: 23px;
  color: ${Theme.colors.previewIconColor};
  line-height: 37px;
  text-align: left;
`;

const SendMessageWrapper = styled.div`
  ${(props) => props.noMobilePadding && 'padding-left: 0 !important;'}
`;
const SendMesssageGrid = styled(Grid)`
  margin-left: 0;
`;

const Reveal = styled('div')`
  height: ${(props) => (props.show ? '160px' : '0')};
  overflow: hidden;
  transition-property: height;
  transition-duration: 150ms !important;
  transition-timing-function: ease-in;
`;

const MessageGuide = createReactClass({
  displayName: 'CheckoutMessageGuide',
  mixins: [FormControllerProxy],

  getInitialState() {
    return {
      showMessageInput: Theme.mobile.isPhone ? false : true,
    };
  },

  _placeholder() {
    let text = t('HAVE_SPECIAL_REQUEST');

    if (this.props.showHint) {
      text = t('ENTER_YOUR_MESSAGE_HERE');
    }
    return text;
  },

  _toggleMessageInput() {
    this.setState({ showMessageInput: !this.state.showMessageInput });
  },

  _renderHeader() {
    return `${t('SEND_A_MESSAGE_TO')} ${this.props.guideName}  (${t(
      'Optional'
    )})`;
  },

  _renderHint() {
    let view = null;

    if (this.props.showHint) {
      view = (
        <div className="CheckoutMessageGuide-hint">
          <div className="CheckoutMessageGuide-hint-icon">
            <i className="af-lamp brand-color" />
          </div>
          <div className="CheckoutMessageGuide-hint-text">
            {t('REQUESTING_A_PICKUP')}
          </div>
        </div>
      );
    }
    return view;
  },

  render() {
    const containerClasses = classnames(
      'MessageGuideContainer',
      'CheckoutSection',
      {
        'no-top-border': !!this.props.borderless,
      }
    );
    return (
      <div className={containerClasses}>
        <SendMessageWrapper
          noMobilePadding={this.props.noMobilePadding}
          className="CheckoutMessageGuide"
          data-testid="checkout-message"
          id="checkout-message"
        >
          <SendMesssageGrid
            gridTemplateColumns={Theme.mobile.isPhone ? '33px 1fr' : ''}
          >
            {Theme.mobile.isPhone && (
              <Toggle
                role="button"
                aria-label={`"Expands "send a message"`}
                aria-expanded={this.state.showMessageInput}
                onClick={() => this._toggleMessageInput()}
                className={`icon anyfont-icon af-promo-${
                  this.state.showMessageInput ? 'minus' : 'plus'
                }`}
              />
            )}
            <h2>{this._renderHeader()}</h2>
          </SendMesssageGrid>
          {this._renderHint()}
          <Reveal show={this.state.showMessageInput}>
            <Textarea
              {...this._formProps('message', {
                placeholder: this._placeholder(),
                ariaLabel: 'Send a message',
                ariaLabelledBy: 'checkout-message',
              })}
            />
          </Reveal>
        </SendMessageWrapper>
      </div>
    );
  },
});

export default MessageGuide;
